var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rightPanel",staticClass:"rightPanel-container",class:{show: _vm.show}},[_c('div',{staticClass:"rightPanel-background"}),_vm._v(" "),_c('div',{staticClass:"rightPanel"},[_c('div',{staticClass:"rightPanel-items"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10757dc7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightPanel/index.vue
// module id = null
// module chunks = 